import { createSlice } from '@reduxjs/toolkit';
import {
  fetchStatusMapItemsThunk,
  fetchStatusMapComponentsThunk,
  createStatusMapItemThunk,
  updateStatusMapItemThunk,
  deleteStatusMapItemThunk,
} from './statusMapActionThunks';

const initialState = {
  items: [],
  components: [],
  loading: { items: false, mutate: false },
  errors: { items: null, mutate: null, components: null },
};

const statusMapSlice = createSlice({
  name: 'statusMap',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // === List ===
      .addCase(fetchStatusMapItemsThunk.pending, (state) => {
        state.loading.items = true;
        state.errors.items = null;
      })
      .addCase(fetchStatusMapItemsThunk.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading.items = false;
      })
      .addCase(fetchStatusMapItemsThunk.rejected, (state, action) => {
        state.loading.items = false;
        state.errors.items = action.payload || 'Failed to load status map items';
      })

      // === Components ===
      .addCase(fetchStatusMapComponentsThunk.fulfilled, (state, action) => {
        state.components = action.payload;
      })
      .addCase(fetchStatusMapComponentsThunk.rejected, (state, action) => {
        state.errors.components = action.payload || 'Failed to load status map components';
      })

      // === Create ===
      .addCase(createStatusMapItemThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(createStatusMapItemThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        state.items.unshift(action.payload);
      })
      .addCase(createStatusMapItemThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to create item';
      })

      // === Update ===
      .addCase(updateStatusMapItemThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(updateStatusMapItemThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        const idx = state.items.findIndex((i) => i.id === action.payload.id);
        if (idx !== -1) state.items[idx] = action.payload;
      })
      .addCase(updateStatusMapItemThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to update item';
      })

      // === Delete ===
      .addCase(deleteStatusMapItemThunk.pending, (state) => {
        state.loading.mutate = true;
        state.errors.mutate = null;
      })
      .addCase(deleteStatusMapItemThunk.fulfilled, (state, action) => {
        state.loading.mutate = false;
        state.items = state.items.filter((i) => i.id !== action.payload);
      })
      .addCase(deleteStatusMapItemThunk.rejected, (state, action) => {
        state.loading.mutate = false;
        state.errors.mutate = action.payload || 'Failed to delete item';
      });
  },
});

export default statusMapSlice.reducer;
